import { InputHTMLAttributes, ReactNode } from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { GenericInput } from './GenericInput';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
  },
  prefixText: {
    backgroundColor: theme.colors.grayBackground,
    borderRadius: `${theme.borderRadius.std}px 0 0 ${theme.borderRadius.std}px`,
    borderRight: `1px solid ${theme.colors.grayBorder}`,
    color: theme.colors.inkSecondary,
    display: 'flex',
    alignItems: 'center',
    paddingInline: theme.marginBase + 'px',
    textAlign: 'center',
  },
  input: {
    ...theme.fonts.caption,
    padding: `13px ${theme.marginBase * 2}px`,
    minWidth: 100,
    width: '100%',
  },
}));

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  containerClass?: string;
  value?: any;
  name?: string;
  error?: string;
  noMargin?: boolean;
  disabled?: boolean;
  prefixText: ReactNode;
}

const WithPrefixInputComponent = ({
  prefixText,
  className,
  ...rest
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classnames(className, classes.container)}>
      <label className={classes.prefixText}>{prefixText}</label>
      <input {...rest} className={classes.input} />
    </div>
  );
};

export const WithPrefixInput = (props: Props) => {
  return (
    <GenericInput
      type="number"
      {...props}
      component={WithPrefixInputComponent}
    />
  );
};
